import useDeceased from "../../../hooks/useDeceased";
import {capitalize} from "../../../helper/tools";

export default function ViewAdminInfos({
    legend,
    deceasedInfos,
    data
}) {
    const { affiliationList } = useDeceased();

    const addressLine = [
        data?.address?.address,
        data?.address?.comp,
    ].filter(Boolean).join(', ') + (data?.address?.zipcode || data?.address?.city ?
        ` - ${[data?.address?.zipcode, data?.address?.city].filter(Boolean).join(' ')}` : '');

    const nameLine = [
        data?.civility === "MME" ? "Madame" : "Monsieur",
        capitalize(data?.firstName),
        data?.lastName?.toUpperCase()
    ].filter(Boolean).join(' ');

    const affiliationLabel = data?.civility === "M" ?
        affiliationList?.maleAffiliation[data?.familyAffiliation - 1] :
        data?.civility === "MME" ?
            affiliationList?.femaleAffiliation[data?.familyAffiliation - 1] :
            "";

    return (
        <fieldset>
            <legend>{legend}</legend>
            <div className="recap-summary">
                <p className="recap-name">{nameLine}</p>
                {affiliationLabel &&
                    <p className="recap-relation">{affiliationLabel} du défunt</p>
                }
                <p className="recap-address"><span>Adresse : </span>{addressLine}</p>
            </div>
        </fieldset>
    )
}
